module.exports = __webpack_public_path__ + "img/2.af85cd06.svg";